export const initFlyoutMenu = header => {
    if (!header) return;

    const flyout = header.querySelector('.flyout');
    const main = document.querySelector('#main');
    if (!flyout || !main) return;

    const resizeObserver = new ResizeObserver(entries => {
        if (entries[0].target === flyout) {
            flyout.style.setProperty('max-height', `calc(100vh - ${header.offsetHeight}px - 2rem)`);
        }
    });
    resizeObserver.observe(flyout);

    window.addEventListener('resize', updateFlyoutContainer, { passive: true });

    let currentMenuItem = null;

    header.querySelectorAll('#main-menu > .menu-item').forEach(menuItem => {
        menuItem.addEventListener('mouseenter', () => {
            const id = menuItem.id.replace('item-', '') || '';

            if (currentMenuItem === id) return;
            currentMenuItem = id;

            const flyoutContainer = flyout.querySelector(`#flyout-${id}`);
            hideFlyout(!!flyoutContainer);
            if (!flyoutContainer) return;
            resetFlyoutContainer(flyoutContainer);

            const flyoutMenu = flyoutContainer.querySelector('.flyout-menu');
            if (!flyoutMenu) return;

            menuItem.classList.add('active');
            flyout.classList.add('open');
            flyoutContainer.classList.add('open');
            flyoutMenu.classList.remove('hide');
            main.classList.add('blurred');
            updateFlyoutContainer();
            showFirstDescription();
            togglePageScroll(true);
        });
    });

    header.addEventListener('mouseleave', () => {
        hideFlyout();
        togglePageScroll(false);
        currentMenuItem = null;
    });

    flyout.querySelectorAll('.flyout-menu > .submenu-item').forEach(flyoutMenuItem => {
        flyoutMenuItem.addEventListener('mouseenter', () => {
            const flyoutContainer = flyoutMenuItem.closest('.flyout-container');
            if (!flyoutContainer) return;

            // Remove active state from submenu items.
            const submenuItems = flyoutContainer.querySelectorAll('.flyout-menu .submenu-item');
            submenuItems.forEach(menuItem => menuItem.classList.remove('active'));

            // Hide all submenus and descriptions.
            flyoutContainer.querySelectorAll('.submenu-description-container').forEach(container => {
                container.classList.remove('open');
                const descriptions = container.querySelectorAll('.submenu-description');
                descriptions.forEach(element => element.classList.add('hide'));
            });
        });
    });

    flyout.querySelectorAll('.submenu-item').forEach(subMenuItem => {
        subMenuItem.querySelector('.link-item')?.addEventListener('mouseenter', () => {
            const flyoutContainer = subMenuItem.closest('.flyout-container');
            if (!flyoutContainer) return;

            hideAllDescriptions();

            let id = subMenuItem.id.replace('item-', '') || '';
            updateDescriptionVisibility(flyoutContainer, `#description-${id}`);

            const currentDescription = flyoutContainer.querySelector(
                `.submenu-description-container.open .submenu-description:not(.hide)`
            );
            if (currentDescription?.innerHTML === '') showFirstDescription();
        });
    });

    function updateFlyoutContainer() {
        const flyoutContainer = flyout.querySelector('.flyout-container.open');
        if (!flyoutContainer) return;

        const flyoutContainerHigherThanWindow = flyoutContainer.scrollHeight > flyout.offsetHeight;
        flyoutContainer.classList.toggle('two-col', !flyoutContainerHigherThanWindow);
        flyoutContainer.classList.toggle('three-col', flyoutContainerHigherThanWindow);
        flyoutContainer.style.setProperty('max-height', flyout.offsetHeight + 'px');
    }

    function hideFlyout(switchToNewFlyout) {
        flyout.classList.remove('open');
        header.querySelectorAll('#main-menu .menu-item').forEach(menuItem => menuItem.classList.remove('active'));
        main.classList.remove('blurred');

        if (!switchToNewFlyout) return;
        flyout.querySelectorAll('.flyout-container').forEach(flyoutContainer => {
            flyoutContainer.classList.remove('open');
            const flyoutMenu = flyoutContainer.querySelector('.flyout-menu');
            flyoutMenu?.childNodes?.forEach(menuItem => menuItem.classList.remove('active'));
            flyoutMenu?.classList?.add('hide');
            resetFlyoutContainer(flyoutContainer);
        });
    }

    function resetFlyoutContainer(container) {
        container.style.setProperty('max-height', '');
        container.classList.add('two-col');
        container.classList.remove('three-col');
    }

    function hideAllDescriptions() {
        flyout.querySelectorAll('.submenu-description').forEach(description => {
            description.classList.add('hide');
        });
    }

    function updateDescriptionVisibility(flyoutContainer, id) {
        const container = flyoutContainer.querySelector('.submenu-description-container');
        const element = flyoutContainer.querySelector(id);
        if (!container || !element) return;
        container.classList.add('open');
        element.classList.remove('hide');
    }

    function showFirstDescription() {
        const currentFlyoutContainer = flyout.querySelector('.flyout-container.open');
        const descriptionContainer = currentFlyoutContainer?.querySelector('.submenu-description-container');
        const firstDescription = descriptionContainer?.querySelector('.submenu-description:first-child');
        if (!firstDescription) return;
        hideAllDescriptions();
        descriptionContainer.classList.add('open');
        firstDescription.classList.remove('hide');
    }

    function togglePageScroll(isFlyoutVisible) {
        if (document.documentElement.scrollHeight <= document.documentElement.clientHeight) return;
        document.documentElement.style.setProperty('overflow', isFlyoutVisible ? 'hidden' : 'auto');
        document.body.style.setProperty('overflow', isFlyoutVisible ? 'scroll' : 'auto');
    }
};
